import request from '@/utils/request'

// 相关任务下拉框的url http://120.237.80.132:8083/api/task/addTaskSelect
export function getCheckTask(taskId) {
  return request({
    url: `task/edit?task_id=${taskId}`,
    method: 'get'
  })
}

// 编辑任务提交按钮
export function submitEditForm(reqParams) {
  return request({
    url: `task/edit`,
    method: 'post',
    data: reqParams
  })
}

// 历史记录
export function getTaskLog(reqParams) {
  return request({
    url: `task/getLogValue`,
    method: 'post',
    data: reqParams
  })
}

